import { epos2Axios, goAxios } from '@/interceptors/axios';

class B2BScheduleService {
  /**
   * Same customer search used by Customer Towel Label Settings.
   */
  findByCustomer(queryString = '') {
    return epos2Axios.get(`/api/assembly/customers?query=${encodeURIComponent(queryString)}`);
  }

  /**
   * Resolve full customer fields (firstname/surname) after assembly search selection.
   */
  getCustomerDetails(queryString = '') {
    return epos2Axios.get(`/api/customers/search?query=${encodeURIComponent(queryString)}`);
  }

  getAccounts() {
    return goAxios.get('/api/b2b-schedule/accounts');
  }

  getDailySchedule(date) {
    return goAxios.get(`/api/b2b-schedule/daily?date=${encodeURIComponent(date)}`);
  }

  createAccount(payload) {
    return goAxios.post('/api/b2b-schedule/accounts', payload);
  }

  toggleDay(scheduleId, dayKey) {
    return goAxios.patch(`/api/b2b-schedule/accounts/${scheduleId}/days/${dayKey}`);
  }

  toggleActive(scheduleId) {
    return goAxios.patch(`/api/b2b-schedule/accounts/${scheduleId}/active`);
  }

  deleteAccount(scheduleId) {
    return goAxios.delete(`/api/b2b-schedule/accounts/${scheduleId}`);
  }
}

export default new B2BScheduleService();
